import type { CategoryAppliesTo } from '../categoryTypes';
import { parseDecimalInput } from '../../../shared/numeric/localeNumeric';

export function parseCsvBoolean(value: string | undefined): boolean | undefined {
  if (value == null || String(value).trim() === '') return undefined;
  const v = String(value).trim().toLowerCase();
  if (['si', 'sí', 's', '1', 'true', 'yes', 'y', 'activo'].includes(v)) return true;
  if (['no', 'n', '0', 'false', 'inactivo'].includes(v)) return false;
  return undefined;
}

export const CSV_BOOLEAN_INVALID_MESSAGE = 'En activo poné si o no.';
export const CSV_ITEM_TYPE_INVALID_MESSAGE = 'En tipo poné fisico o servicio.';

/** Vacío = no tocar. Valor raro = error (no se traga en silencio). */
export function parseCsvBooleanStrict(
  value: string | undefined
): { value: boolean | undefined; error?: string } {
  if (value == null || String(value).trim() === '') return { value: undefined };
  const parsed = parseCsvBoolean(value);
  if (parsed === undefined) return { value: undefined, error: CSV_BOOLEAN_INVALID_MESSAGE };
  return { value: parsed };
}

export function parseCsvAppliesTo(value: string | undefined): CategoryAppliesTo | undefined {
  if (value == null || String(value).trim() === '') return undefined;
  const v = String(value).trim().toLowerCase();
  if (v === 'product' || v === 'producto' || v === 'fisico' || v === 'físico') return 'product';
  if (v === 'service' || v === 'servicio') return 'service';
  if (v === 'both' || v === 'ambos') return 'both';
  return undefined;
}

export function parseCsvItemType(value: string | undefined): 'physical' | 'service' | undefined {
  if (value == null || String(value).trim() === '') return undefined;
  const v = String(value).trim().toLowerCase();
  if (v === 'servicio' || v === 'service') return 'service';
  if (v === 'fisico' || v === 'físico' || v === 'physical' || v === 'producto') return 'physical';
  return undefined;
}

export function parseCsvItemTypeStrict(
  value: string | undefined
): { value: 'physical' | 'service' | undefined; error?: string } {
  if (value == null || String(value).trim() === '') return { value: undefined };
  const parsed = parseCsvItemType(value);
  if (!parsed) return { value: undefined, error: CSV_ITEM_TYPE_INVALID_MESSAGE };
  return { value: parsed };
}

/** Inverso de parseCsvAppliesTo: emite la etiqueta legible que usa la plantilla. */
export function formatCsvAppliesTo(value: CategoryAppliesTo): string {
  if (value === 'service') return 'servicio';
  if (value === 'both') return 'ambos';
  return 'producto';
}

/** Inverso de parseCsvItemType: emite la etiqueta legible que usa la plantilla. */
export function formatCsvItemType(value: 'physical' | 'service' | string | null | undefined): string {
  return value === 'service' ? 'servicio' : 'fisico';
}

export function parseOptionalNumber(value: string | undefined): number | null | undefined {
  if (value == null || String(value).trim() === '') return undefined;
  const n = parseDecimalInput(String(value));
  if (n === null) return null;
  return n;
}

export function parseOptionalInt(value: string | undefined): number | null | undefined {
  if (value == null || String(value).trim() === '') return undefined;
  const n = parseDecimalInput(String(value), { integerOnly: true, min: 0 });
  if (n === null) return null;
  return n;
}
